import React__default from 'react';
import { u as useElementWidth } from './SkeletonContainer-fd90b3af.js';
import { c as classNames } from './className-0524835a.js';

const PanelGrid = ({ className, singleColumn, children }) => {
    const { ref, width } = useElementWidth();
    const classes = classNames('PanelGrid', className, {
        'PanelGrid-singleColumn': singleColumn,
        'PanelGrid-compact': width < 800
    });
    return React__default.createElement("div", { ref: ref, className: classes }, children);
};
const Column = ({ children }) => {
    return React__default.createElement("div", { className: "PanelGrid-column" }, children);
};
PanelGrid.Column = Column;

export { PanelGrid as P };
